import styled from 'styled-components';

const Loading = () => {
  return (
    <Background>
      <LoadingText>로딩중 ...</LoadingText>
      {/* <img src={Spinner} alt="로딩중" width="5%" /> */}
    </Background>
  );
};

const Background = styled.div`
  position: absolute;
  width: 100vw;
  min-width: 1920px;
  height: 100%;
  top: 0;
  left: 0;
  background: #ffffffb7;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingText = styled.div`
  color: #000;
  font: 1rem 'Noto Sans KR';
  text-align: center;
  font-family: Inter;
  font-size: 1.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export default Loading;
